import React from 'react';
import { Tag, Space, Typography } from 'antd';
import { FEATURE_BY_KEY } from './featureAccess';

const { Text } = Typography;

// Renders a set of feature keys as colored AntD tags.
// `tone`: 'solid' (effective/allowed) or 'deny' (struck-through, for denied).
const FeatureTags = ({ featureKeys, empty = 'None', tone = 'solid' }) => {
    if (!featureKeys || featureKeys.length === 0) {
        return <Text type="secondary" style={{ fontSize: 12, fontStyle: 'italic' }}>{empty}</Text>;
    }
    return (
        <Space size={[4, 4]} wrap>
            {featureKeys.map((key) => {
                const feature = FEATURE_BY_KEY[key];
                if (!feature) return null;
                return (
                    <Tag
                        key={key}
                        color={tone === 'deny' ? 'default' : feature.color}
                        style={{
                            marginInlineEnd: 0,
                            textDecoration: tone === 'deny' ? 'line-through' : 'none',
                            opacity: tone === 'deny' ? 0.65 : 1,
                        }}
                    >
                        {feature.label}
                    </Tag>
                );
            })}
        </Space>
    );
};

export default FeatureTags;
